import React from 'react';

const OnboardingV3 = React.lazy(() => import('./OnboardingV3'));

export default OnboardingV3;
